import React from 'react';
import styled, { css } from 'styled-components';
import { flexBoxCenter, layerHPF, layerHPG } from '../../styles/commonStyles';

const YellowDisplayBox = ({
  wrapperXSize,
  wrapperYSize,
  innerXLayer,
  innerYLayer,
}) => {
  return (
    <Wrapper width={wrapperXSize} height={wrapperYSize}>
      <FirstLayer width={innerXLayer} height={innerYLayer}></FirstLayer>
    </Wrapper>
  );
};

export default YellowDisplayBox;

const Wrapper = styled.div`
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}

${layerHPF}
  border-radius: 6px;
  ${flexBoxCenter}
`;

const FirstLayer = styled.div`
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}

    ${layerHPG}
  border-radius: 2px;
`;
